import styles from './Layout.module.scss'

export const IframeOverlay = () => <div className={styles.iframeOverlay}/>
